import React, { useEffect } from 'react';

const SignOut = () => {
  useEffect(() => {
    localStorage.clear(); // Remove all local storage items
    window.location.href = '/signin'; // Redirect to login page
  }, []);

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Logging out...</h2>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#f5f6fa',
  },
  title: {
    color: '#4078c0',
    fontSize: '2rem',
  },
};

export default SignOut;